export const formatCampaignDateRange = (startDate?: Date, endDate?: Date): string => {
  if (startDate) {
    const startDateString = startDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });

    if (endDate) {
      const endDateString = endDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
      return `${startDateString} - ${endDateString}`;
    }

    return startDateString;
  }
  return '';
};
